import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { isAvailableLang } from "helpers/is";
import { useLanguage } from "hooks/useLanguage";
import { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useLocalizationStore } from "stores/localization";
import { setLocalStorageItem } from "utils/localStorage";

export const LanguagePath = () => {
  const changeLanguage = useLocalizationStore((s) => s.changeLanguage);
  const navigate = useNavigate();
  const { lang } = useParams();
  const { path } = useLanguage();

  useEffect(() => {
    if (!lang) {
      return;
    }

    const langLower = lang.toLowerCase();
    if (!isAvailableLang(langLower)) {
      // navigate("/404");
      return;
    }

    setLocalStorageItem(STORAGE_LANGUAGE_NAME, langLower);
    changeLanguage(langLower);

    // если выбрали en — убираем префикс из URL
    if (langLower === "en") {
      navigate(path, { replace: true });
    }
  }, [lang, path, changeLanguage, navigate]);

  return <Outlet />;
};
